angular.module('mercury.modules.cashup.edit', []);
